import http from './http'

const Api = {
    login: (url,params)=>{
        return http.post(url,params)
    },
};
export default Api;